//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"KnuckleRatio",1,0],[0,"KnuckleSmoothAngle",1,0],[1,"MassDensity",0,"Expression",0],[0,"MaterialGradeName",1,0],[0,"MaterialGradeOption",1,0],[0,"MaterialName",1,0],[0,"MaterialOption",1,0],[1,"OppositeThickness",0,"Expression",0],[0,"RestrictThicknessToMaterial",1,0],[0,"ThickenOption",1,0],[1,"Thickness",0,"Expression",0],[0,"ThicknessOption",1,0],[0,"ThicknessSourceOption",1,0],[0,"ThicknessStr",1,0],[0,"WeightRating",1,0]],[],[]];
SPLM.Features.ShipDesign.PlateStockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PlateStockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.PlateStockBuilder.ThickenOptions = Object.freeze({
    "SingleSided" : "SingleSided", "TwoSided" : "TwoSided", "Symmetric" : "Symmetric"});

SPLM.Features.ShipDesign.PlateStockBuilder.ThicknessSourceOptions = Object.freeze({
    "File" : "File", "List" : "List"});

export default SPLM;